import React from "react";
import "./AuthPageWrapper.less";
import SideBar from "../../../containers/SideBar";
import { Layout } from "antd";

type Props = {
    children: JSX.Element | JSX.Element[];
    showSideBar: boolean;
};

export default function AuthPageWrapper({ showSideBar, children }: Props) {
    if (showSideBar) {
        return (
            <Layout>
                <SideBar />
                <Layout className="general-layout">{children}</Layout>
            </Layout>
        );
    }

    return <Layout>{children}</Layout>
}
